// External Dependencies
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FormControlLabel, Button, Checkbox, Tooltip, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import moment from 'moment';
import RemoveCircleRoundedIcon from '@material-ui/icons/RemoveCircleRounded';
import RemoveIcon from '@material-ui/icons/Remove';
import ClearIcon from '@material-ui/icons/Clear';
import { toast } from 'react-toastify';

// Internal Dependencies
import DatePicker from './datepicker';
import TimePicker from './timepicker';
import ExceptionDayPanel from './exceptionDayPanel';
import DefaultDayPanel from './defaultDayPanel';
import PopularHours from './popularHours';
import { IsEmpty } from '../../common/checks';
import OverLoading from '../global/OverLoading';

const monIdx = 0; const tueIdx = 1; const wedIdx = 2; const thuIdx = 3; const friIdx = 4; const satIdx = 5; const sunIdx = 6; const eveIdx = 7; const
  holIdx = 8;

class OpeningHours extends Component {
  constructor(props) {
    super(props);

    const defaultOpeningHours = {
      default: [
        { day: 'Monday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Tuesday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Wednesday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Thursday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Friday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Saturday', isOpen: true, is24Hours: false, hours: [] },
        { day: 'Sunday', isOpen: true, is24Hours: false, hours: [] },
      ],
      eve:     { isOpen: true, is24Hours: false, hours: [] },
      holiday: { isOpen: true, is24Hours: false, hours: [] },
      others:  '',
    };

    // Add exceptions only if hasExceptions prop is true
    if (props.hasExceptions) {
      defaultOpeningHours.exceptions = [];
    }

    this.state = {
      addMoreMon:       false, showMon:          false, monFromInput:     '', monToInput:       '',
      addMoreTue:       false, showTue:          false, tueFromInput:     '', tueToInput:       '',
      addMoreWed:       false, showWed:          false, wedFromInput:     '', wedToInput:       '',
      addMoreThu:       false, showThu:          false, thuFromInput:     '', thuToInput:       '',
      addMoreFri:       false, showFri:          false, friFromInput:     '', friToInput:       '',
      addMoreSat:       false, showSat:          false, satFromInput:     '', satToInput:       '',
      addMoreSun:       false, showSun:          false, sunFromInput:     '', sunToInput:       '',
      addMoreEve:       false, showEve:          false, eveFromInput:     '', eveToInput:       '',
      addMoreHol:       false, showHol:          false, holFromInput:     '', holToInput:       '',
      openDialog:       false,
      openConfirmation: false,
      confirmed:        false,
      loading:          true,
      data:             [],
      tempData:         [],
      originalData:     [],
      entity:           null,
      date:             moment(new Date()).format('DD-MM-YYYY'),
      uniqueHours:      [],
      defaultOpeningHours,
    };
  }

  componentDidMount() {
    const { childRef } = this.props;
    if (childRef) {
      childRef(this);
    }
    this.fetchData();
  }

  fetchData = async () => {
    if (this.props.match && this.props.params && this.props.id) {
      try {
        const entity = await this.props.getEntity(this.props.id);
        if (entity) {
          // Push current unique open hours to array
          if (!IsEmpty(entity.uniqueOpenHours)) {
            const uniqueHours = [...this.state.uniqueHours];
            for (let x = 0; x < entity.uniqueOpenHours.length; x += 1) {
              const findObj = _.some(uniqueHours, entity.uniqueOpenHours[x]);
              if (findObj === false) {
                uniqueHours.push(entity.uniqueOpenHours[x]);
              }
            }
            this.setState({ uniqueHours });
          }

          this.setState({ entity }, () => {
            let response;
            if (this.state.entity.openingHours !== null) {
              response = JSON.parse(JSON.stringify(this.state.entity.openingHours));

              if (IsEmpty(response.others)) {
                response.others = '';
              }

              this.setState({
                data:         response,
                originalData: this.state.entity.openingHours,
              }, () => {
                if (this.state.data.length !== 0) {
                  this.setFormState(this.state.data);
                }
                this.setState({ loading: false });
              });
            } else {
              const dataOpening = this.props.dataOpening || this.state.defaultOpeningHours;
              response = dataOpening;
              this.setState({
                data:         response,
                originalData: dataOpening,
              }, () => {
                if (this.state.data.length !== 0) {
                  this.setFormState(this.state.data);
                }
                this.setState({ loading: false });
              });
            }
          });
        }
      } catch (error) {
        console.error('Error fetching entity:', error);
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  }

  setFormState = (arr) => {
    const stateUpdates = {
      showMon:    arr.default[monIdx].isOpen,
      showTue:    arr.default[tueIdx].isOpen,
      showWed:    arr.default[wedIdx].isOpen,
      showThu:    arr.default[thuIdx].isOpen,
      showFri:    arr.default[friIdx].isOpen,
      showSat:    arr.default[satIdx].isOpen,
      showSun:    arr.default[sunIdx].isOpen,
      showEve:    arr.eve.isOpen,
      showHol:    arr.holiday.isOpen,
      addMoreMon: arr.default[monIdx].is24Hours,
      addMoreTue: arr.default[tueIdx].is24Hours,
      addMoreWed: arr.default[wedIdx].is24Hours,
      addMoreThu: arr.default[thuIdx].is24Hours,
      addMoreFri: arr.default[friIdx].is24Hours,
      addMoreSat: arr.default[satIdx].is24Hours,
      addMoreSun: arr.default[sunIdx].is24Hours,
      addMoreEve: arr.eve.is24Hours,
      addMoreHol: arr.holiday.is24Hours,
    };

    this.setState(stateUpdates);
  }

  onAddHour = (idx, e) => {
    e.preventDefault();
    const hourHandlers = {
      [monIdx]: () => this.onAddHelper(monIdx, 'addMoreMon', this.state.monFromInput, this.state.monToInput, 'monFromInput', 'monToInput'),
      [tueIdx]: () => this.onAddHelper(tueIdx, 'addMoreTue', this.state.tueFromInput, this.state.tueToInput, 'tueFromInput', 'tueToInput'),
      [wedIdx]: () => this.onAddHelper(wedIdx, 'addMoreWed', this.state.wedFromInput, this.state.wedToInput, 'wedFromInput', 'wedToInput'),
      [thuIdx]: () => this.onAddHelper(thuIdx, 'addMoreThu', this.state.thuFromInput, this.state.thuToInput, 'thuFromInput', 'thuToInput'),
      [friIdx]: () => this.onAddHelper(friIdx, 'addMoreFri', this.state.friFromInput, this.state.friToInput, 'friFromInput', 'friToInput'),
      [satIdx]: () => this.onAddHelper(satIdx, 'addMoreSat', this.state.satFromInput, this.state.satToInput, 'satFromInput', 'satToInput'),
      [sunIdx]: () => this.onAddHelper(sunIdx, 'addMoreSun', this.state.sunFromInput, this.state.sunToInput, 'sunFromInput', 'sunToInput'),
      [eveIdx]: () => this.onAddHelper(eveIdx, 'addMoreEve', this.state.eveFromInput, this.state.eveToInput, 'eveFromInput', 'eveToInput'),
      [holIdx]: () => this.onAddHelper(holIdx, 'addMoreHol', this.state.holFromInput, this.state.holToInput, 'holFromInput', 'holToInput'),
    };

    if (hourHandlers[idx]) {
      hourHandlers[idx]();
    }
  }

  onAddHelper = (idx, addField, fromInputState, toInputState, fromInput, toInput) => {
    if (fromInputState === '' || toInputState === '') return;

    const newData = { ...this.state.data };

    switch (idx) {
      case 7:
        newData.eve.hours.push({ from: fromInputState, to: toInputState });
        break;
      case 8:
        newData.holiday.hours.push({ from: fromInputState, to: toInputState });
        break;
      default:
        newData.default[idx].hours.push({ from: fromInputState, to: toInputState });
        break;
    }

    this.onPushUniqueHours(fromInputState, toInputState);
    this.setState({
      [addField]:  false,
      [fromInput]: '',
      [toInput]:   '',
      data:        newData,
    });
  }

  onPushUniqueHours = (from, to) => {
    if (from !== '' && to !== '') {
      const findObj = _.some(this.state.uniqueHours, { from, to });
      if (!findObj) {
        const uniqueHours = [...this.state.uniqueHours, { from, to }];
        const distinctHours = _.uniqWith(uniqueHours, _.isEqual);
        this.setState({ uniqueHours: distinctHours });
        if (this.props.setUniqueOpenHours) {
          this.props.setUniqueOpenHours(distinctHours);
        }
      }
    }
  }

  onRemoveHour = (e, dataType, item, arr) => {
  e.preventDefault();
  const newData = _.cloneDeep(this.state.data);

  switch (dataType) {
    case 'eve':
      _.remove(newData.eve.hours, (hour) => _.isEqual(hour, item));
      break;
    case 'holiday':
      _.remove(newData.holiday.hours, (hour) => _.isEqual(hour, item));
      break;
    case 'default': {
      // For default days, we need to know which day index
      const dayIndex = this.state.data.default.findIndex((day) => day.hours === arr.hours);
      if (dayIndex !== -1) {
        _.remove(newData.default[dayIndex].hours, (hour) => _.isEqual(hour, item));
      }
    }
      break;
    case 'exception': {
      // For exceptions, we need to find the correct exception by date
      const exceptionIndex = newData.exceptions.findIndex((exception) => exception.hours === arr.hours);
      if (exceptionIndex !== -1) {
        _.remove(newData.exceptions[exceptionIndex].hours, (hour) => _.isEqual(hour, item));
      } }
      break;
    default:
      break;
  }

  this.setState({ data: newData });
  }

  onShowForm = (idx, fromInput, toInput) => {
    const dayConfigs = {
      [monIdx]: { show: this.state.showMon, data: this.state.data.default[monIdx], closedText: 'Closed On Mondays' },
      [tueIdx]: { show: this.state.showTue, data: this.state.data.default[tueIdx], closedText: 'Closed On Tuesdays' },
      [wedIdx]: { show: this.state.showWed, data: this.state.data.default[wedIdx], closedText: 'Closed On Wednesdays' },
      [thuIdx]: { show: this.state.showThu, data: this.state.data.default[thuIdx], closedText: 'Closed On Thursdays' },
      [friIdx]: { show: this.state.showFri, data: this.state.data.default[friIdx], closedText: 'Closed On Fridays' },
      [satIdx]: { show: this.state.showSat, data: this.state.data.default[satIdx], closedText: 'Closed On Saturdays' },
      [sunIdx]: { show: this.state.showSun, data: this.state.data.default[sunIdx], closedText: 'Closed On Sundays' },
      [eveIdx]: { show: this.state.showEve, data: this.state.data.eve, closedText: 'Closed On Eves' },
      [holIdx]: { show: this.state.showHol, data: this.state.data.holiday, closedText: 'Closed On Holidays' },
    };

    const config = dayConfigs[idx];
    if (!config) return null;

    if (config.show) {
      const addFieldState = `addMore${['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun', 'Eve', 'Hol'][idx]}`;
      return this.onShowFormHelper({
        arr:            config.data,
        idx,
        addState:       this.state[addFieldState],
        addField:       addFieldState,
        fromInputState: this.state[fromInput],
        toInputState:   this.state[toInput],
        fromInput,
        toInput,
        dataType:       idx === eveIdx
          ? 'eve'
          : (idx === holIdx ? 'holiday' : 'default'),
      });
    } else {
      return <div><i>{config.closedText}</i></div>;
    }
  }

  onShowFormHelper = ({ arr, idx, addState, addField, fromInputState, toInputState, fromInput, toInput, dataType }) => (
    <div className="col">
      <div style={{ margin: '10px 0 20px 0', borderTop: '1px dotted #939393', borderBottom: '1px dotted #939393' }}>
        <FormControlLabel
          control={(
            <Checkbox
              checked={arr.is24Hours}
              onChange={(e, checked) => {
                  this.setState({ openConfirmation: true }, () => {
                    this.setState({ tempData: [arr, addField, checked, idx] });
                  });
              }}
              color="primary"
              name="name"
            />
          )}
          label="24 Hours"
          style={{ margin: 0 }}
        />
      </div>

      {arr.hours.length > 0 ? (
        <div>
          {this.onShowHours(arr, dataType)}
        </div>
      ) : ('')}
      <div>
        {!arr.is24Hours && addState ? (
          <div className="row" style={{ paddingLeft: '15px', paddingBottom: '15px' }}>
            <TimePicker placeholder="From" defaultValue={fromInputState} name={fromInput} pushData={(e) => { this.onInputChange(idx, e); }} isDisabled={false} />
              &nbsp;
            <RemoveIcon style={{ marginTop: '20px' }} />
&nbsp;
            <TimePicker placeholder="To" defaultValue={toInputState} name={toInput} pushData={(e) => { this.onInputChange(idx, e); }} isDisabled={false} />

            <Tooltip title="Cancel">
              <ClearIcon style={{ cursor: 'pointer', marginTop: '20px', marginLeft: '5px' }} onClick={() => this.setState({ [addField]: false })} />
            </Tooltip>
          </div>
        ) : ('')}
      </div>
      {!arr.is24Hours && !addState ? (
        <div>
          <Button onClick={() => { this.setState({ [addField]: true }); }}>{arr.hours.length > 0 ? ('Add More Hours') : ('Add A New Opening Hour')}</Button>
        </div>
      ) : ('')}
    </div>
  )

  makeKey = () => {
    const length = 10;
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  onShowHours = (arr, dataType = 'default') => {
    if (!arr.is24Hours) {
      const time = _.sortBy(arr.hours, (hour) => hour.from).map((item) => (
        <div key={`${JSON.stringify(item)}-${this.makeKey()}`} className="row" style={{ paddingLeft: '15px', paddingBottom: '15px' }}>
          <TimePicker placeholder="From" defaultValue={item.from} name="To" pushData={() => {}} isDisabled />
          &nbsp;
          <RemoveIcon style={{ marginTop: '20px' }} />
        &nbsp;
          <TimePicker placeholder="To" defaultValue={item.to} name="From" pushData={() => {}} isDisabled />

          <Tooltip title="Remove">
            <RemoveCircleRoundedIcon
              style={{ cursor: 'pointer', marginTop: '20px', marginLeft: '5px' }}
              onClick={(e) => { this.onRemoveHour(e, dataType, item, arr); }}
            />
          </Tooltip>
        </div>
      ));
      return time;
    }
  }

  handleConfirmation = () => {
    const [arr, addField, checked, idx] = this.state.tempData;
    this.setFullDay(arr, addField, checked, idx);
  }

  handleOthersChange = (e) => {
    const newData = _.cloneDeep(this.state.data);
    newData.others = e.target.value;
    this.setState({ data: newData });
  }

  setFullDay = (arr, addField, checked, idx) => {
    const newData = _.cloneDeep(this.state.data);
    let targetArr;

    switch (idx) {
      case 7:
        targetArr = newData.eve;
        break;
      case 8:
        targetArr = newData.holiday;
        break;
      default:
        targetArr = newData.default[idx];
        break;
    }

    targetArr.is24Hours = checked;

    if (checked && this.state.confirmed === true) {
      targetArr.hours = [];
      this.setState({
        [addField]:       true,
        data:             newData,
        openConfirmation: false,
        confirmed:        false,
      });
    } else if (!checked) {
      this.setState({
        openConfirmation: false,
        confirmed:        false,
        data:             newData,
      });
    } else {
      targetArr.is24Hours = false;
      this.setState({
        data:             newData,
        openConfirmation: false,
      });
    }
  }

  setOpen = (checked, idx) => {
    const showStates = {
      [monIdx]: 'showMon', [tueIdx]: 'showTue', [wedIdx]: 'showWed',
      [thuIdx]: 'showThu', [friIdx]: 'showFri', [satIdx]: 'showSat',
      [sunIdx]: 'showSun', [eveIdx]: 'showEve', [holIdx]: 'showHol',
    };

    this.setState({ [showStates[idx]]: checked });

    const newData = _.cloneDeep(this.state.data);
    let targetArr;

    switch (idx) {
      case 7:
        targetArr = newData.eve;
        break;
      case 8:
        targetArr = newData.holiday;
        break;
      default:
        targetArr = newData.default[idx];
        break;
    }

    targetArr.isOpen = checked;

    if (checked === false) {
      targetArr.is24Hours = false;
      targetArr.hours = [];
    }

    this.setState({ data: newData });
  }

  setDate = (value) => {
    this.setState({ date: value });
  };

  onAddExcDay = (date) => {
    if (!this.props.hasExceptions) return;

    const exceptionDates = !IsEmpty(this.state.data.exceptions)
      ? _.map(this.state.data.exceptions, (d) => d.date) : [];

    if (!IsEmpty(date) && !exceptionDates.includes(date)) {
      this.setState({ openDialog: false }, () => {
        const newData = _.cloneDeep(this.state.data);
        const openHours = {
          date,
          isOpen:    true,
          is24Hours: false,
          hours:     [],
        };
        newData.exceptions.push(openHours);
        this.setState({ data: newData });
      });
    } else {
      toast.error('Similar date has already been applied.');
    }
  }

  onAddExcHour = (item, fromInput, toInput) => {
    if (!this.props.hasExceptions) return;

    const newData = _.cloneDeep(this.state.data);
    const index = newData.exceptions.findIndex((exception) => exception.date === item.date);
    if (index !== -1) {
      newData.exceptions[index].hours.push({ from: fromInput, to: toInput });
      this.onPushUniqueHours(fromInput, toInput);
      this.setState({ data: newData });
    }
  }

  onDelExc = (item) => {
    if (!this.props.hasExceptions) return;

    const newData = _.cloneDeep(this.state.data);
    _.remove(newData.exceptions, item);
    this.setState({ data: newData });
  }

  setExcFull = (item, checked) => {
    if (!this.props.hasExceptions) return;

    const newData = _.cloneDeep(this.state.data);
    const index = newData.exceptions.findIndex((exception) => exception.date === item.date);
    if (index !== -1) {
      newData.exceptions[index].is24Hours = checked;
      if (checked) {
        newData.exceptions[index].hours = [];
      }
      this.setState({ data: newData });
    }
  }

  setExcOpen = (item, checked) => {
    if (!this.props.hasExceptions) return;

    const newData = _.cloneDeep(this.state.data);
    const index = newData.exceptions.findIndex((exception) => exception.date === item.date);
    if (index !== -1) {
      newData.exceptions[index].isOpen = checked;
      if (!checked) {
        newData.exceptions[index].hours = [];
        newData.exceptions[index].is24Hours = false;
      }
      this.setState({ data: newData });
    }
  }

  onShowExc = () => {
    if (!this.props.hasExceptions || this.state.data.length === 0) return null;

    const data = _.sortBy(this.state.data.exceptions, (exception) => exception.date).map((item) => (
      <div style={{ paddingBottom: '1px' }} key={`${JSON.stringify(item)}-${this.makeKey()}`}>
        <ExceptionDayPanel
          item={item}
          onShowHours={this.onShowHours}
          onAddExcHour={this.onAddExcHour}
          onAddViaDrop={(i, f, t) => this.onAddExcHour(i, f, t)}
          setExcFull={this.setExcFull}
          setExcOpen={this.setExcOpen}
          onDelExc={this.onDelExc}
        />
      </div>
    ));
    return data;
  }

  onInputChange = (idx, e) => {
    this.setState({ [e.target.name]: e.target.value }, () => this.onAddHour(idx, e));
  }

  onCatchDrop = (idx, e) => {
    this.setState({ [e.fromInputKey]: e.dragData.from, [e.toInputKey]: e.dragData.to }, () => this.onAddHour(idx, e));
  }

  onRestore = () => {
    this.setState({
      data:    _.cloneDeep(this.state.originalData),
      loading: true,
    }, () => {
      this.setFormState(this.state.data);
      this.setState({ loading: false });
    });
  }

  onSubmit = async (e) => {
    if (e) e.preventDefault();

    this.setState({ loading: true });

    try {
      const data = {
        openingHours:    this.state.data,
        uniqueOpenHours: this.state.uniqueHours,
      };

      if (this.props.updateEntity) {
        await this.props.updateEntity(data, this.props.id);
        this.setState({
          originalData: _.cloneDeep(this.state.data),
          loading:      false,
        });
      } else if (this.props.set) {
        this.props.set(this.state.data);
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error saving opening hours:', error);
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div>
        {this.state.loading && <OverLoading />}
        {!this.state.loading ? (
          <div>
            <h4>Default</h4>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <DefaultDayPanel
                  data={this.state.data.default[sunIdx]}
                  day="Sunday"
                  showDay={this.state.showSun}
                  idx={sunIdx}
                  fromInput="sunFromInput"
                  toInput="sunToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(sunIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[monIdx]}
                  day="Monday"
                  showDay={this.state.showMon}
                  idx={monIdx}
                  fromInput="monFromInput"
                  toInput="monToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(monIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[tueIdx]}
                  day="Tuesday"
                  showDay={this.state.showTue}
                  idx={tueIdx}
                  fromInput="tueFromInput"
                  toInput="tueToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(tueIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[wedIdx]}
                  day="Wednesday"
                  showDay={this.state.showWed}
                  idx={wedIdx}
                  fromInput="wedFromInput"
                  toInput="wedToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(wedIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[thuIdx]}
                  day="Thursday"
                  showDay={this.state.showThu}
                  idx={thuIdx}
                  fromInput="thuFromInput"
                  toInput="thuToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(thuIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[friIdx]}
                  day="Friday"
                  showDay={this.state.showFri}
                  idx={friIdx}
                  fromInput="friFromInput"
                  toInput="friToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(friIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.default[satIdx]}
                  day="Saturday"
                  showDay={this.state.showSat}
                  idx={satIdx}
                  fromInput="satFromInput"
                  toInput="satToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(satIdx, e); }}
                />

                <DefaultDayPanel
                  data={this.state.data.eve}
                  day="Eve"
                  showDay={this.state.showEve}
                  idx={eveIdx}
                  fromInput="eveFromInput"
                  toInput="eveToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(eveIdx, e); }}
                />
                <DefaultDayPanel
                  data={this.state.data.holiday}
                  day="Holiday"
                  showDay={this.state.showHol}
                  idx={holIdx}
                  fromInput="holFromInput"
                  toInput="holToInput"
                  setOpen={this.setOpen}
                  onShowForm={this.onShowForm}
                  droppedData={(e) => { this.onCatchDrop(holIdx, e); }}
                />

                <div className="mt-4">
                  <h5>Additional Opening Hours Information</h5>
                  <div className="form-group">
                    <label htmlFor="others-hours">Custom Hours Format</label>
                    <textarea
                      id="others-hours"
                      className="form-control"
                      rows="3"
                      value={this.state.data.others || ''}
                      onChange={this.handleOthersChange}
                    />
                  </div>
                </div>

                {this.props.hasExceptions && (
                  <>
                    <hr />
                    <h4>Exceptions</h4>
                    {this.onShowExc()}
                    <Grid item xs={12} md={12} style={{ marginTop: '20px' }}>
                      <Button color="primary" variant="contained" onClick={() => { this.setState({ openDialog: true }); }}>Add Exceptions</Button>
                      <Button color="secondary" variant="contained" onClick={this.onRestore} style={{ marginLeft: '10px' }}>Restore All Changes</Button>
                    </Grid>
                  </>
                )}
              </div>

              <div className="col-md-6 col-sm-12">
                <div style={{ position: 'fixed', height: '100vh', top: '20%', overflowY: 'auto', padding: '30px 30px 150px' }}>
                  <PopularHours
                    setHour={() => {
                      if (this.props.setUniqueOpenHours) {
                        this.props.setUniqueOpenHours(this.state.uniqueHours);
                      }
                    }}
                    getTiming={this.state.uniqueHours}
                  />
                </div>
              </div>
            </div>

            {this.props.hasExceptions && (
              <Dialog open={this.state.openDialog} onClose={() => { this.setState({ openDialog: false }); }} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Exception</DialogTitle>
                <DialogContent>
                  <DatePicker
                    onSetDate={this.setDate}
                    exception={this.state.data.exceptions}
                    triggerAddExc={this.onAddExcDay}
                  />
                </DialogContent>
                <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}>
                  <Button color="secondary" variant="contained" onClick={() => { this.setState({ openDialog: false }); }}>Close</Button>
                </DialogActions>
              </Dialog>
            )}

            <Dialog
              fullWidth
              open={this.state.openConfirmation}
              onClose={() => { this.setState({ openConfirmation: false }); }}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Are you sure?</DialogTitle>
              <DialogContent>
                All the current timings below on this day scheduled will be removed.
              </DialogContent>
              <DialogActions style={{ marginRight: '20px', marginBottom: '20px' }}>
                <Button
                  color="primary"
                  variant="contained"
                  style={{ cursor: 'pointer' }}
                  onClick={() => { this.setState({ confirmed: true }, this.handleConfirmation); }}
                >
                  Update
                </Button>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => { this.setState({ openConfirmation: false, confirmed: false }); }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        ) : ('')}
      </div>
    );
  }
}

OpeningHours.defaultProps = {
  params:             null,
  id:                 null,
  hasExceptions:      false,
  dataOpening:        null,
  setUniqueOpenHours: null,
  set:                null,
};

OpeningHours.propTypes = {
  childRef: PropTypes.func.isRequired,
  match:    PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  }).isRequired,
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
  id:                 PropTypes.string,
  hasExceptions:      PropTypes.bool,
  getEntity:          PropTypes.func.isRequired,
  updateEntity:       PropTypes.func.isRequired,
  dataOpening:        PropTypes.shape(Object),
  setUniqueOpenHours: PropTypes.func,
  set:                PropTypes.func,
};

export default OpeningHours;
